// VerifyTokenPage (public routes) and AuthVerifyRedirect (protected routes)
// both match `/auth/verify`. A successful verify flips to protected routes
// before VerifyTokenPage's own navigation lands, so this flag makes
// AuthVerifyRedirect defer instead of clobbering the intended destination.
const VERIFY_IN_PROGRESS_KEY = 'token_verify_in_progress'

export const setVerifyInProgress = () => {
  try {
    sessionStorage.setItem(VERIFY_IN_PROGRESS_KEY, '1')
  } catch {
    // sessionStorage can be unavailable (private mode); ignore.
  }
}

export const clearVerifyInProgress = () => {
  try {
    sessionStorage.removeItem(VERIFY_IN_PROGRESS_KEY)
  } catch {
    // ignore
  }
}

export const isVerifyInProgress = () => {
  try {
    return sessionStorage.getItem(VERIFY_IN_PROGRESS_KEY) === '1'
  } catch {
    return false
  }
}
